/* Mikaya — copy-to-clipboard for revealed discount codes.
   Delegated so it works for the newsletter reveal and the welcome popup. */
(function () {
  function flash(btn, text) {
    var original = btn.getAttribute('data-mk-label') || btn.textContent;
    if (!btn.getAttribute('data-mk-label')) btn.setAttribute('data-mk-label', original);
    btn.textContent = text;
    btn.classList.add('is-copied');
    window.clearTimeout(btn._mkTimer);
    btn._mkTimer = window.setTimeout(function () {
      btn.textContent = btn.getAttribute('data-mk-label');
      btn.classList.remove('is-copied');
    }, 1800);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mk-coupon-copy]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('[data-mk-coupon]') || document;
    var codeEl = wrap.querySelector('[data-mk-coupon-code]');
    var code = codeEl ? (codeEl.textContent || '').trim() : '';
    if (!code) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(
        function () { flash(btn, 'Copied!'); },
        function () { flash(btn, 'Copy failed'); }
      );
    } else {
      try {
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        flash(btn, 'Copied!');
      } catch (err) {
        flash(btn, 'Copy failed');
      }
    }
  });
})();
